import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { NavigationComponent } from './navigation.component';
import { DlrPoliciesComponent } from '../dlrs/dlr-policies/dlr-policies.component';
import { DlrUndelMccComponent } from '../dlrs/dlr-undel-mcc/dlr-undel-mcc.component';
import { DlrUndelMsisdnComponent } from '../dlrs/dlr-undel-msisdn/dlr-undel-msisdn.component';
import { DlrSummaryComponent } from '../dlrs/dlr-summary/dlr-summary.component';
import { ClickerSummaryComponent } from '../clicker-summary/clicker-summary.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: NavigationComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'dlr_policies',
            component: DlrPoliciesComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'undel_cache_by_mcc',
            component: DlrUndelMccComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'undel_cache_by_msisdn',
            component: DlrUndelMsisdnComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'dlr_response_summary',
            component: DlrSummaryComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'clicker_summary',
            component: ClickerSummaryComponent,
            canActivate: [AuthGuard]
          }
        ]
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NavigationRoutingModule { }
